import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';



import { LandingComponent } from './landing.component';
import { LandingService } from './landing.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LandingComponent
  ],
  exports:[
    LandingComponent
  ],
  providers:[
    LandingService
  ]
})
export class LandingModule { }
